<template>
    <div class="container-fluid">
        <div class="card">
            <div class="row p-3" v-if="title">
                <div class="col-12 col-md-6 align-self-center">
                    <h5>{{title}}</h5>
                </div>
                <div class="col-12 col-md-6 d-flex justify-content-end mt-2 mt-md-0" v-if="button_title">
                    <button type="button" class="btn btn-primary" @click.pr.prevent="buttonClick()"><font-awesome-icon :icon="this.buttonIcon" /> {{button_title}}</button>
                </div>
            </div>
            <div class="card-body">
                <slot name="content"></slot>
            </div>

            <div class="card-footer" v-if="footer">
                <slot name="footer"></slot>
            </div>

        </div>
    </div>
</template>

<script>
import button from "bootstrap/js/src/button";

export default {
    props: ['title' , 'button_title', "buttonIcon", 'button_route', 'footer'],
    name: "CardComponent",
    methods: {
        buttonClick(){
            window.location.href = this.button_route;
        }
    },
    mounted() {
        if(this.buttonIcon === 'fa-plus'){
            return "fa-solid fa-plus"
        }
    }
}
</script>

<style scoped>

</style>
